import { render } from "./GroupIncome.vue?vue&type=template&id=4d04d540&scoped=true"
import script from "./GroupIncome.vue?vue&type=script&lang=js"
export * from "./GroupIncome.vue?vue&type=script&lang=js"

import "./GroupIncome.vue?vue&type=style&index=0&id=4d04d540&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d04d540"]])

export default __exports__